// Import necessary hooks from React
import { useState } from "react";
// Import necessary components
import { DataGridTable } from "../../../common";
// Import necessary custom hooks and components
import {
  useResubmitRequestContext,
  useResubmitRequest,
  ResubmitAddItemSampleRequestModal,
  ResubmitEditDeleteItemSampleRequestModal,
} from "./";
import { ResubmitAddItemsInBulkSampleRequestModal } from "./";
// Import necessary MUI components
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";

export function ResubmitItemList() {
  // Hook to get the function to set the item form to edit
  const { setItemFormToEdit } = useResubmitRequest();
  // Hook to get the state from the Resubmit Request Context
  const { state } = useResubmitRequestContext();
  // State to control the visibility of the Edit Item Sample Request Modal
  const [openEditItemSampleRequestModal, setOpenEditItemSampleRequestModal] =
    useState(false);
  // Function to open the Edit Item Sample Request Modal and set the item to edit
  const handleOpenEditItemSampleRequestModal = (data) => {
    setItemFormToEdit(data);
    setOpenEditItemSampleRequestModal(true);
  };
  // State to control the visibility of the Add Item Modal
  const [openAddItemModal, setOpenAddItemModal] = useState(false);
  // Function to open the Add Item Modal
  const handleOpenAddItemModal = () => setOpenAddItemModal(true);
  // State to control the visibility of the AddItemInBulkSampleRequestModal
  const [openAddItemsInBulkModal, setOpenAddItemsInBulkModal] = useState(false);
  // Function to open the AddItemInBulkSampleRequestModal
  const handleOpenAddItemsInBulkModal = () => setOpenAddItemsInBulkModal(true);

  // Extract the items from the state
  let data = state.sampleRequestDetails.items;
  // Title for the DataGridTable
  const title = "All Items";
  // Description for the DataGridTable based on the number of items
  const description =
    data?.length < 1
      ? "Please add atleast one item to be able to submit a new sample request"
      : "Click on a row to edit the corresponding item";

  // Modify each item in the data array to remove unnecessary properties and add a custom property
  data?.forEach((item, i) => {
    item.editOrDeleteItem = "Edit Or Delete";
    [
      "HODStatus",
      "_id",
      "date",
      "dateModified",
      "executiveChefStatus",
      "procurementStatus",
      "supplierList",
      "supplierStatus",
      "userStatus",
      "requesterSampleImage",
    ].forEach((prop) => delete item[prop]);
  });

  // Function to handle row click events, setting the item to edit and opening the Edit Item Sample Request Modal
  function handleRowClick(event) {
    setItemFormToEdit({ ...event.row, rowId: event.row.id });
    handleOpenEditItemSampleRequestModal(event.row);
  }

  return (
    <div>
      {data && (
        <DataGridTable
          title={title}
          description={description}
          data={data}
          handleRowClick={handleRowClick}
          button={
            <Grid item>
              {/*  Render a button for adding a new item */}
              <Button
                size="small"
                variant="contained"
                sx={{
                  padding: "10px 20px",
                  mr: "20px",
                  fontSize: "14px",
                  backgroundColor: "#c7ab79",
                  "&:hover": {
                    backgroundColor: "#c4943f",
                  },
                  textTransform: "capitalize",
                }}
                onClick={handleOpenAddItemModal}
              >
                Add Item
              </Button>
              <Button
                size="small"
                variant="contained"
                sx={{
                  padding: "10px 20px",
                  mr: "20px",
                  fontSize: "14px",
                  backgroundColor: "#c7ab79",
                  "&:hover": {
                    backgroundColor: "#c4943f",
                  },
                  textTransform: "capitalize",
                }}
                onClick={handleOpenAddItemsInBulkModal}
              >
                Add Items in bulk
              </Button>
            </Grid>
          }
        />
      )}
      {/* Conditionally Render the EditItemSampleRequestModal for editing an item in the list */}
      {state?.itemFormToEdit && (
        <ResubmitEditDeleteItemSampleRequestModal
          open={openEditItemSampleRequestModal}
          setOpen={setOpenEditItemSampleRequestModal}
          handleOpen={handleOpenEditItemSampleRequestModal}
          data={state.itemFormToEdit}
        />
      )}
      {/* Render the AddItemSampleRequestModal for adding new items */}
      <ResubmitAddItemSampleRequestModal
        open={openAddItemModal}
        setOpen={setOpenAddItemModal}
        handleOpen={handleOpenAddItemModal}
      />

      {/* Render the AddItemsInBulkSampleRequestModal for adding new items */}
      <ResubmitAddItemsInBulkSampleRequestModal
        open={openAddItemsInBulkModal}
        setOpen={setOpenAddItemsInBulkModal}
        handleOpen={handleOpenAddItemsInBulkModal}
      />
    </div>
  );
}
